import React, { useEffect, useMemo, useRef, useState } from "react";
import HeroEvents from "./HeroEvents.jsx";
import getFallbackEvents from "./fallbackEvents.js";

const AUTOPLAY_MS = 3500;

// ==========================================
// 1. ADD YOUR HARDCODED EVENTS HERE
// ==========================================
const hardcodedEvents = [
  
  
  
  {
    id: "904",
    name: "SMAAASH DAY",
    tagline: "SMAAASH DAY",
    event_date: "18-11-2026",
    
    // 🚨 CRITICAL: The timer NEEDS this exact format (YYYY-MM-DDTHH:MM:SS)
    event_date_raw: "2026-11-18T10:00:00", 
    
    location: "Smaaash, Pan India",
    price: "49",
    image: "/images/smaaashday16.jpg",
      mobileImage: "/images/smaaashday8.jpg",  
        bookingLink: "https://esmaaash.in/smaaashday26/register/",
  },
    {
    id: "904",
    name: "SMAAASH DAY",
    tagline: "SMAAASH DAY",
    event_date: "18-11-2026",
    
    // 🚨 CRITICAL: The timer NEEDS this exact format (YYYY-MM-DDTHH:MM:SS)
    event_date_raw: "2026-11-18T10:00:00", 
    
    location: "Smaaash, Pan India",
    price: "49",
    image: "/images/Associate-Partner-1600x900PX.jpg",
      mobileImage: "/images/Associate-Partner-800x450PX.jpg",  
        bookingLink: "https://esmaaash.in/smaaashday26/register/",
  },
  
  {
    id: "904",
    name: "SMAAASH DAY",
    tagline: "SMAAASH DAY",
    event_date: "18-11-2026",
    
    // 🚨 CRITICAL: The timer NEEDS this exact format (YYYY-MM-DDTHH:MM:SS)
    event_date_raw: "2026-11-18T10:00:00", 
    
    location: "Smaaash, Pan India",
    price: "49",
    image: "/images/Gifting-Partner-1600pxX900px.jpg",
      mobileImage: "/images/Gifting-Partner-800pxX450px.jpg",  
        bookingLink: "https://esmaaash.in/smaaashday26/register/",
  },
  {
    id: "904",
    name: "SMAAASH DAY",
    tagline: "SMAAASH DAY",
    event_date: "18-11-2026",
    
    // 🚨 CRITICAL: The timer NEEDS this exact format (YYYY-MM-DDTHH:MM:SS)
    event_date_raw: "2026-11-18T10:00:00", 
    
    location: "Smaaash, Pan India",
    price: "49",
    image: "/images/Radio-Partner-1600pxX900px.jpg",
      mobileImage: "/images/Radio-Partner-800pxX450px.jpg",  
        bookingLink: "https://esmaaash.in/smaaashday26/register/",
  },
  {
    id: "904",
    name: "SMAAASH DAY",
    tagline: "SMAAASH DAY",
    event_date: "18-11-2026",
    
    // 🚨 CRITICAL: The timer NEEDS this exact format (YYYY-MM-DDTHH:MM:SS)
    event_date_raw: "2026-11-18T10:00:00", 
    
    location: "Smaaash, Pan India",
    price: "49",
    image: "/images/Ticketing-Partner-1600pxX900px.jpg",
      mobileImage: "/images/Ticketing-Partner-800pxX450px.jpg",  
        bookingLink: "https://esmaaash.in/smaaashday26/register/",
  },
];

/**
 * Hero banner carousel: rotates through the event banners (each with its live
 * countdown card below). Data comes from /api/events; falls back to the dated
 * sample events, then to the CMS hero slide.
 */
export default function EventsShowcase({ fallbackSlides = [], viewerLabel = "", streamLive = false }) {
  const [events, setEvents] = useState([]);
  const [now, setNow] = useState(() => Date.now());
  const [active, setActive] = useState(0);
  const pausedRef = useRef(false);

  // One fetch feeds the hero.
  useEffect(() => {
    let cancelled = false;
    fetch("/api/events")
      .then((r) => r.json())
      .then((d) => {
        if (!cancelled && Array.isArray(d) && d.length) setEvents(d);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  // Prefer the live API; if empty, use the dated fallback events; only if BOTH
  // are empty fall back to the CMS hero slide (no date → no countdown).
  const slides = useMemo(() => {
    
    // ==========================================
    // 2. MERGE HARDCODED EVENTS WITH DATABASE EVENTS
    // ==========================================
    const combinedEvents = [...hardcodedEvents, ...events];
    const source = combinedEvents.length ? combinedEvents : getFallbackEvents();
    
    if (source.length) {
      // Map BOTH API shapes: the resolved shape (title/date/venue/link/status)
      // and the raw events.json shape (name/event_date/location/bookingLink).
      return source.map((e, i) => ({
        id: e.id ?? `event-${i}`,
        title: e.title || e.name || "Upcoming Event",
        venue: e.venue || e.location || e.city || "",
        image: e.image,
        mobileImage: e.mobileImage || e.mobile_image || null,
        link: e.link || e.bookingLink || "/events",
        
        // This line grabs 'event_date_raw' from BOTH the database and your hardcoded array
        date: e.event_date_raw || e.date || e.event_date || null,
        
        status: e.status || "upcoming",
      }));
    }
    return fallbackSlides.map((s, i) => ({
      id: `slide-${i}`,
      title: s.title || s.alt || "eSMAAASH",
      venue: s.tagline || "",
      image: s.src,
      link: s.link || "#",
      date: null,
      status: "upcoming",
    }));
  }, [events, fallbackSlides]);

  // 1s ticker drives the countdown.
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const N = slides.length;

  // Keep active in range if the list size changes.
  useEffect(() => {
    if (active >= N && N > 0) setActive(0);
  }, [N, active]);

  // Auto-rotate through the banners (pauses on hover).
  useEffect(() => {
    if (N <= 1) return;
    const id = setInterval(() => {
      if (!pausedRef.current) setActive((a) => (a + 1) % N);
    }, AUTOPLAY_MS);
    return () => clearInterval(id);
  }, [N]);

  if (!N) return null;

  return (
    <div
      className="events-showcase"
      onMouseEnter={() => (pausedRef.current = true)}
      onMouseLeave={() => (pausedRef.current = false)}
    >
      <HeroEvents
        slides={slides}
        active={active % N}
        onSelect={setActive}
        now={now}
        viewerLabel={viewerLabel}
        streamLive={streamLive}
      />
    </div>
  );
}